/**
 * CONTEXT MODELS
 */

interface Snackbar {
  isOpen: boolean;
  text: string | null;
}

export type App = {
  isHeaderVisible: boolean;
  isMenuListVisible: boolean;
  snackbar: Snackbar;
  isNotFound: boolean;
  isForbidden: boolean;
  isServerError: boolean;
  isNotSameSubDomain: boolean;
};

export const initialState: App = {
  isHeaderVisible: true,
  isMenuListVisible: true,
  snackbar: {
    isOpen: false,
    text: null,
  },
  isNotFound: false,
  isForbidden: false,
  isServerError: false,
  isNotSameSubDomain: false,
};
